import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DropdownModule } from '../../../common/dropdown/dropdown.module';
import { RtUICoreOverlayModule } from './../../../core/core.module';
import { TimePickerDropdownComponent } from './time-picker-dropdown.component';

@NgModule({
  declarations: [TimePickerDropdownComponent],
  exports: [TimePickerDropdownComponent],
  imports: [CommonModule, RtUICoreOverlayModule, DropdownModule],
})
export class TimePickerDropdownModule {}
export { TimePickerDropdownComponent } from './time-picker-dropdown.component';
